import React from 'react';
import { ModernOnboardingFlow } from './ModernOnboardingFlow';

export function OnboardingFlow() {
  return <ModernOnboardingFlow />;
} 